import { createSelector } from 'reselect'

const productCategorySelector = state => state.uiState.approvals.category
const approvalsStateSelector = state => state.approvals.approvals
const approvalEntitySelector = state => state.entities.approvals
const currentApprovalsStateSelector = state => state.approvals.currentApproval

const approvalsSelectorFunc = (approvals, refs) => (
  approvals && refs
    ? refs.map(id => approvals[id])
    : []
)

const currentApprovalSelectorFunc = (approvals, id) => (
  approvals
    ? approvals[id]
    : undefined
)

const approvalsSelector = createSelector(
  approvalEntitySelector,
  approvalsStateSelector,
  approvalsSelectorFunc,
)

const currentApprovalSelector = createSelector(
  approvalEntitySelector,
  currentApprovalsStateSelector,
  currentApprovalSelectorFunc
)

export {
  productCategorySelector,
  approvalsSelector,
  currentApprovalSelector,
  approvalEntitySelector,
}
